export const FIND_ASSIGNABLE_GROUPS = `
  query FindAssignableGroups($filter: FindAssignableGroupsFilter!, $page: PageRequest) {
    group {
      findAssignableGroups(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          inAssignments
        }
      }
    }
  }
`;
